import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '../service/http.service';
import { Promotion } from '../promotion';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { StudyProgram } from '../study-program';
import * as moment from 'moment';
import { CKEDITORCONFIG } from '../ckeditor-config';
import * as Editor from '../../libs/ckeditor';

@Component({
  selector: 'app-promotion-edit',
  templateUrl: './promotion-edit.component.html',
  styleUrls: ['./promotion-edit.component.css']
})
export class PromotionEditComponent implements OnInit {

  selectedPromotion!: Promotion;

  promotionForm!: FormGroup;
  studyPrograms: StudyProgram[] = [];

  programForm!: FormGroup;

  display = false;

  editorConfig: any = CKEDITORCONFIG;

  public Editor = Editor;

  constructor(
    private route: ActivatedRoute,
    private httpService: HttpService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {

   }

  ngOnInit() {
    let promotionId = parseInt(this.route.snapshot.paramMap.get("promotionId")!);
    this.httpService.getPromotionById(promotionId).subscribe(promotion => {
      this.selectedPromotion = promotion;
      this.initForm();
    });
    this.httpService.getStudyPrograms().subscribe(res => {
      this.studyPrograms = res;
    });

    this.programForm = this.formBuilder.group({
      name: ["", [Validators.required, Validators.minLength(2)]]
    });
  }

  initForm(){
    this.promotionForm = this.formBuilder.group({
      from: [this.selectedPromotion.start.format("YYYY-MM-DD"), Validators.required],
      to: [this.selectedPromotion.end.format("YYYY-MM-DD"), Validators.required],
      description: [this.selectedPromotion.description, [Validators.minLength(3), Validators.required]],
      studyProgram: [this.selectedPromotion.studyProgram, Validators.required]
    });
  }

  change(){
    if(this.promotionForm.value.studyProgram == -1){
      this.promotionForm.get("studyProgram")!.setValue(null);
      this.display = true;
    }
  }

  compareId(program1: StudyProgram, program2: StudyProgram) {
    return program1 && program2 ? program1.id == program2.id : program1 == program2;
  }

  sendForm(){
    if(this.promotionForm.invalid){
      console.log("promotion form is invalid");
      return;
    }
            // remove zero width space in the comment
    let description = this.promotionForm.value.description.replace(/\u200B/g,"");
    let promotion = new Promotion(
      moment(this.promotionForm.value.from).utc(true),
      moment(this.promotionForm.value.to).utc(true),
      description,
      this.promotionForm.value.studyProgram,
      this.selectedPromotion.id
    );

    this.httpService.updatePromotion(promotion).subscribe(() => {
      this.router.navigateByUrl("/management/promotions");
    });
  }

  cancelEdit(){
    this.router.navigateByUrl("/management/promotions");
  }

  sendStudyProgram(){
    if(this.programForm.invalid){
      return;
    }
    let program = new StudyProgram(
      this.programForm.value.name
    );
    this.httpService.postStudyProgram(program)
    .subscribe(program => {
      this.studyPrograms.push(program);
      this.display = false;
    });
  }

}
